import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// ui components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Slide from "@material-ui/core/Slide";

// core components 
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InputAdornment from '@material-ui/core/InputAdornment';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';

// icons
import LoadingIcon from "@material-ui/icons/Cached";

// services
import { MaskCPF, MaskCel, MaskCEP, formateDate, MaskDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UseGetApiendPointDiferent, UsePostApi, UsePutApi, } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { convertDate } from 'beaktShared/helpers/masks';

const useStyles = makeStyles(styles);

export default function AlteracaoVendaCliente({ detalheVenda, handleVoltar, handleProximoStep }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, setValue, errors, setError, clearError, getValues, handleSubmit } = useForm({ mode: "onBlur" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    useEffect(() => {
        loadListAtendentes(detalheVenda.estabelecimentoId);
        setStatusVendaSelected(detalheVenda.vendaStatus);
        setAtendente(detalheVenda.usuarioId);
    }, [detalheVenda]);

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);

    const [clienteId, setclienteId] = React.useState(0);

    const handleCPFChange = e => {

        let cpf = e.target.value;
        if (cpf === "")
            return;

        setloadingValidateCPF(true);
        const endPoint = "clientes/clientebycpf/" + cpf;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                if (clienteId == 0) {

                    setloadingValidateCPF(false);
                    return;
                }

            }
            let dados = result.data
            setValue('nome', dados.nome);
            setValue('rg', dados.rg);
            setValue('email', dados.email);
            setValue('dataNascimento', dados.dataNascimento);
            setValue('celular', dados.celular);
            setloadingValidateCPF(false);

            return true;
        });
    }

    const [loadingCep, setloadingCep] = React.useState(false);
    const handleCEPBlur = (e) => {
        let cep = e.target.value;
        if (cep === "")
            return;
        cep = cep.replace("-", "");

        setloadingCep(true);
        const endPoint = "https://viacep.com.br/ws/" + cep + "/json";
        UseGetApiendPointDiferent(endPoint).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                setloadingCep(false);
                return false;
            }
            let resultcep = result.data;
            setValue('rua', resultcep.logradouro);
            setValue('complemento', resultcep.complemento);
            setValue('bairro', resultcep.bairro);
            setValue('cidade', resultcep.localidade);
            setValue('estado', resultcep.uf);
            setloadingCep(false);
        });
    };
    
    const handleAvancar = () => {
        let data = getValues();
        let _detalhesVenda = detalheVenda;
        _detalhesVenda.cliente_Nome = data.nome;
        _detalhesVenda.cliente_CPF = data.cpf;
        _detalhesVenda.cliente_RG = data.rg;
        _detalhesVenda.cliente_Email = data.email;
        _detalhesVenda.cliente_DTNascimento = data.dataNascimento != null ? convertDate(data.dataNascimento) : null;
        _detalhesVenda.cliente_Celular = data.celular;
        _detalhesVenda.cliente_Rua = data.rua;
        _detalhesVenda.cliente_Numero = data.numero;
        _detalhesVenda.cliente_Bairro = data.bairro;
        _detalhesVenda.cliente_Cidade = data.cidade;
        _detalhesVenda.cliente_Estado = data.estado;
        _detalhesVenda.cliente_Cep = data.cep;
        _detalhesVenda.usuarioId = session.id;
        _detalhesVenda.vendaStatus = statusVendaSelected;
        _detalhesVenda.usuarioVenda = atendente;

        handleProximoStep(_detalhesVenda);
    }

    const [statusVendaOptions, setStatusVendaOptions] = React.useState([
        { text: "Finalizado Ativo", value: "FinalizadoAtivo" },
        { text: "Cancelado", value: "Cancelado" },
    ]);

    const [statusVendaSelected, setStatusVendaSelected] = React.useState("");
    const handleSelectStatusVenda = (event) => {
        let value = event;
        setStatusVendaSelected(value)
        setValue("vendaStatus", value);
    }

    const [atendente, setAtendente] = React.useState();
    const [isLoadingAtendentes, setisLoadingAtendentes] = React.useState(false);
    const [listSelectAtendentes, setlistSelectAtendentes] = React.useState([]);
    const loadListAtendentes = (estabelecimentoId) => {
        setisLoadingAtendentes(true);
        UseGetApiSimple("usuarios/atendentebyestabelecimento/" + estabelecimentoId, 0).then(result => {
        if (result.status !== 200) {
            setisLoadingAtendentes(false);
            showNotification(result.message, 'danger');
            return false;
        }

        setisLoadingAtendentes(false);
        setlistSelectAtendentes(result.data);

        return true;
      });
    }
  
    const handleAtendenteChange = (value) => {
        setAtendente(value);
        errors.atendente = false;
    }

    return (
        <>
            <GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <SnackbarContent
                            color={"info"}
                            message={t('label.Changes_applied_only_to_customer_data_on_sale')}
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('sidebar.sale_data')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                inputRef={register({ required: true })}
                                label="Estabelecimento"
                                name="estabelecimentoDescricao"
                                defaultValue={detalheVenda.estabelecimentoDescricao}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                inputRef={register({ required: true })}
                                label="Nº Venda"
                                name="venda"
                                defaultValue={detalheVenda.vendaId}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                inputRef={register({ required: true })}
                                label="Data Venda"
                                name="dataVenda"
                                defaultValue={detalheVenda.dataVenda != null ? formateDate(detalheVenda.dataVenda) : null}
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                        </FormControl>
                    </GridItem>
                    
                </GridContainer>
                
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={"select__label"}>Vendedor</label>
                            <Select 
                                name="usuarioVenda"
                                styles={ValidSelect(false)} 
                                classNamePrefix="select"
                                isSearchable={true}
                                placeholder="Selecione"
                                isLoading={isLoadingAtendentes}
                                options={listSelectAtendentes}
                                getOptionLabel={({ nome }) => nome}
                                getOptionValue={({ usuarioId }) => usuarioId}
                                value={listSelectAtendentes.filter(f => f.usuarioId == atendente)}
                                onChange={(value) => handleAtendenteChange(value.usuarioId !== null ? value.usuarioId : "")}
                                ref={() => register( { name: "usuarioVenda" })}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={"select__label"}>Status Venda</label>
                            <Select
                                name="vendaStatus"
                                styles={ValidSelect(false)} 
                                classNamePrefix="select"
                                isSearchable={true}
                                options={statusVendaOptions}
                                value={statusVendaOptions.filter(({ value }) => value == statusVendaSelected)}      
                                getOptionLabel={({ text }) => text}
                                getOptionValue={({ value }) => value} 
                                onChange={(value) => handleSelectStatusVenda(value.value)}
                                ref={() => register( { name: "vendaStatus" })}
                            />
                        </FormControl>
                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('avaliation.client_data')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                inputRef={register({ required: true })}
                                label="Nome *"
                                name="nome"
                                defaultValue={detalheVenda.cliente_Nome}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                            {errors.nome && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.cpf ? true : false}
                                label="CPF *"
                                onBlur={handleCPFChange}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="cpf"
                                defaultValue={detalheVenda.cliente_CPF}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskCPF
                                }}
                            />
                            {errors.cpf &&
                                <FormHelperText className={classes.labelRootError}>
                                    <span>{errors.cpf.message} </span>
                                </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="RG"
                            InputLabelProps={{ shrink: true }}
                            name="rg"
                            defaultValue={detalheVenda.cliente_RG}
                            inputRef={register({ required: true })}
                        />
                    </GridItem>
                </GridContainer>
                <br></br>
                <GridContainer>
                    <GridItem xs={12} sm={3} md={3}>
                        <TextField
                            fullWidth
                            error={errors.email ? true : false}
                            label="E-mail*"
                            variant="outlined"
                            inputRef={register({
                                required: true,
                                pattern: {
                                    value: /^\S+@\S+$/i,
                                    message: t('label.invalid_email')
                                },
                                maxLength: {
                                    value: 50,
                                    message: t('label.enter_a_maximum_of_50_characters')
                                }
                            })}
                            name="email"
                            defaultValue={detalheVenda.cliente_Email}
                            InputLabelProps={{ shrink: true }}
                        />
                        <FormHelperText>
                            {errors.email && <span className="obg">
                                {errors.email.message === "" ? t('label.required') : errors.email.message}
                            </span>}
                        </FormHelperText>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.dataNascimento ? true : false}
                                label={t('label.date_of_birth')}
                                variant="outlined"
                                inputRef={register({ required: false })}
                                name="dataNascimento"
                                defaultValue={detalheVenda.cliente_DTNascimento != null ? formateDate(detalheVenda.cliente_DTNascimento) : null}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskDate,
                                }}
                            />
                            {errors.cpf &&
                                <FormHelperText className={classes.labelRootError}>
                                    <span>{errors.cpf.message} </span>
                                </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Celular*"
                            InputLabelProps={{ shrink: true }}
                            name="celular"
                            defaultValue={detalheVenda.cliente_Celular}
                            inputRef={register({ required: true })}
                            error={errors.celular ? true : false}
                            InputProps={{ inputComponent: MaskCel }}
                        />
                        <FormHelperText>
                            {errors.celular && <span className="obg">{t('label.required')}</span>}
                        </FormHelperText>
                    </GridItem>
                </GridContainer>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo">
                            <h6>{t('Endereço Cliente')} </h6>
                        </div>
                    </GridItem>
                    <GridItem xs={12} sm={4} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.cep ? true : false}
                                label={t('label.cep') + " *"}
                                onBlur={handleCEPBlur}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="cep"
                                defaultValue={detalheVenda.cliente_Cep}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 10 }}
                                InputProps={{
                                    inputComponent: MaskCEP,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {loadingCep && <LoadingIcon className="rotate" />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errors.cep && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cep.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={6}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.rua ? true : false}
                                label={t('label.street') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="rua"
                                defaultValue={detalheVenda.cliente_Rua}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {errors.rua && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.rua.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.numero ? true : false}
                                label={t('label.number') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="numero"
                                efaultValue={detalheVenda.cliente_Numero}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 8 }}
                            />
                            {errors.numero && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.numero.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <br></br>
                <GridContainer>
                    <GridItem xs={12} sm={2} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.bairro ? true : false}
                                label={t('label.neighborhood') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="bairro"
                                defaultValue={detalheVenda.cliente_Bairro}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {errors.bairro && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.bairro.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.cidade ? true : false}
                                label={t('label.city') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="cidade"
                                defaultValue={detalheVenda.cliente_Cidade}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {errors.cidade && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.cidade.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={1}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.estado ? true : false}
                                label={t('label.state') + " *"}
                                variant="outlined"
                                inputRef={register({
                                    required: true,
                                })}
                                name="estado"
                                defaultValue={detalheVenda.cliente_Estado}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 2 }}
                            />
                            {errors.estado && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.estado.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
            </GridContainer>
            <GridContainer className="mt-4">
                <GridItem xs={12} sm={12} md={12}>
                    <center>
                        <Button onClick={() => handleVoltar()} color="transparent" >
                            {t('label.return')}
                        </Button>
                        <Button onClick={() => handleAvancar()} color="primary" >
                            {t('label.advance')}
                        </Button>
                    </center>
                </GridItem>
            </GridContainer>
        </>
    );
}

